<div class="dialog-header border-0 py-4">
  <h2 class="dialog-title text-gray-900">
    <!-- <app-keenicon
      name="arrow-left"
      class="fs-2 cursor-pointer"
      type="solid"
    ></app-keenicon> -->
    <!-- {{ "APP.CONFIRM_SHIFT_EXIT" | translate }} -->
  </h2>
  <!-- A way out. The dialog opens with `disableClose`, so without this the
       only control on it was "เข้าสู่คอร์สเรียน" — and entering starts the
       clock on a course with limited time. Closing returns a falsy result, so
       nothing starts. -->
  <!-- <button
    type="button"
    aria-label="Close"
    class="btn-close"
    data-testid="start-video-close"
    (click)="onClose()"
  ></button> -->
</div>
<div class="dialog-content py-4 text-center text-gray-800">
  <div class="row py-4">
    <div class="fs-1 fw-semibold pb-8 text-gray-900">
      ยินดีต้อนรับสู่บทเรียน
    </div>

    <section #monitorPaused>
      <app-keenicon name="time" class="fs-2qx position-absolute left-50 ms-2"></app-keenicon>
      <app-keenicon name="screen" class="fs-4tx"></app-keenicon>
    </section>
    <section #description class="fs-4 py-8">
      <div class="">คอร์สเรียนนี้มีเวลาในการเรียนจำกัด</div>
      <div class="">
        ระบบจะทำการนับเวลาเรียนตามการใช้งานจริงเมื่อมีการเปิดหน้าต่างการเรียนค้างไว้
      </div>
      <div class="">หากต้องการพักชั่วคราวหรือหยุดเรียนคอร์สนี้สามารถกดปุ่ม</div>
    </section>

    <div class="">
      <!-- A PICTURE of the button, not the button — it shows the control the
           sentence above is talking about. A real `<button>` here, however
           inert, is still focusable and still reads to a screen reader as
           something to press: pressing it would pause the course before the
           student has started it. A span cannot be pressed at all. The little
           cursor was `position: fixed` with a hard-coded margin, so it was
           measured against the window rather than the button and sat half
           outside it at every size but one. -->
      <span class="btn btn-sm btn-primary mb-8 pause-sample position-relative" role="presentation" aria-hidden="true">
        <span class="pause-sample__cursor position-absolute d-inline-flex">
          <app-keenicon name="mouse-circle" class="fs-1 svg svg-icon"></app-keenicon>
        </span>
        <div class="d-flex align-items-center gap-2">
          <app-keenicon name="abstract-5" type="solid" class="fs-2 svg svg-icon"></app-keenicon>
          พักการเรียนชั่วคราว
        </div>
      </span>
    </div>
    <section #note class="fs-4">
      <div class="text-gray-800">เพื่อให้ระบบหยุดนับเวลาได้</div>
      <!-- An advisory note, set in red and underlined, read as a broken link
           inside an error. It is a caution: amber, weighted label, no rule. -->
      <div class="fs-6 pause-note">
        <span class="pause-note__label fw-bolder">*หมายเหตุ</span>
        เมื่อเวลาหมดลงคุณจะไม่สามารถเข้าสู่คอร์สเรียนนี้ได้อีก
      </div>
    </section>
  </div>
</div>
<div class="dialog-footer flex-center">
  @if (!videoLoading()) {
  <button class="btn btn-primary btn-get-started px-10 col-12 col-sm-auto" (click)="getStarted()">
    เข้าสู่คอร์สเรียน
  </button>
  } @else {
  <button class="btn btn-primary btn-get-started px-7 col-12 col-sm-auto" [disabled]="true">
    <div class="d-flex align-items-center gap-2 justify-content-center w-100">
      <div class="spinner-border w-15px h-15px" role="status"></div>
      <span class="">กำลังโหลดวิดีโอ</span>
    </div>
  </button>
  }
</div>